import { graphql } from 'src/graphql';

export const RequestToJoinTeamChangeStatus = graphql(`
  mutation requestToJoinTeamChangeStatus($_id: ID!, $status: Int!) {
    requestToJoinTeamChangeStatus(_id: $_id, status: $status) {
      _id
    }
  }
`);
